import React from 'react';
import { PATTERN_PALETTE, deriveColor } from '../../logic/patternColor';
import { PatternColorSwatch } from './PatternColorSwatch';

interface PatternColorPickerProps {
  patternId: string;
  value: string | undefined;
  onChange: (hex: string) => void;
}

export const PatternColorPicker: React.FC<PatternColorPickerProps> = ({
  patternId,
  value,
  onChange,
}) => {
  const suggested = deriveColor(patternId);
  const effective = value ?? suggested;

  return (
    <div>
      <span className="block text-[10px] font-bold uppercase tracking-widest text-ink-faint mb-2">
        Color
      </span>
      <div className="flex flex-wrap gap-2">
        {PATTERN_PALETTE.map((hex) => (
          <PatternColorSwatch
            key={hex}
            name={`pattern-color-${patternId}`}
            color={hex}
            checked={hex === effective}
            onSelect={() => onChange(hex)}
            label={`Color ${hex}`}
          />
        ))}
      </div>
      <p className="mt-1 text-[10px] text-ink-faint">
        Suggested: <span style={{ color: suggested }}>●</span> auto-derived
      </p>
    </div>
  );
};
